import { useEffect } from 'react';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  canonicalUrl?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogType?: string;
}

export default function useSEO({
  title,
  description,
  keywords,
  canonicalUrl,
  ogTitle,
  ogDescription,
  ogType = 'website',
}: SEOProps) {
  useEffect(() => {
    const defaultTitle = '亚洲在线 · 亚洲数字生活一站式平台 | 娱乐资讯购物社交';
    const defaultDesc = '亚洲在线是专为亚洲用户打造的综合数字服务平台，覆盖娱乐、资讯、购物、社交等多元场景。';
    const defaultKeywords = '亚洲在线,亚洲在线娱乐平台,亚洲在线资讯服务,亚洲在线购物,亚洲在线社交,亚洲数字生活,亚洲在线会员';

    document.title = title ? `${title} | 亚洲在线` : defaultTitle;

    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', description || defaultDesc);
    setMeta('keywords', keywords || defaultKeywords);

    if (canonicalUrl) {
      let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
      if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        document.head.appendChild(link);
      }
      link.setAttribute('href', canonicalUrl);
    }

    setMeta('og:title', ogTitle || title || defaultTitle, true);
    setMeta('og:description', ogDescription || description || defaultDesc, true);
    setMeta('og:type', ogType, true);
    if (canonicalUrl) setMeta('og:url', canonicalUrl, true);

    setMeta('twitter:title', ogTitle || title || defaultTitle);
    setMeta('twitter:description', ogDescription || description || defaultDesc);
  }, [title, description, keywords, canonicalUrl, ogTitle, ogDescription, ogType]);
}